import { on } from 'shared/javascripts/util/events'

/**
 * Binds the space bar, for whoever owns playback on the page.
 *
 * One handler per page, not per player: several players each toggling themselves on the same key is
 * how a single press ended up starting every video at once.
 *
 * `handle` returns whether it found a player to act on; only then is the page kept from scrolling.
 */
export function onPlayPauseShortcut(handle: () => boolean): () => void {
  return on(document, 'keydown', (event: KeyboardEvent) => {
    // Anything else focused — an input, a button, the player's own controls — makes its own use of the key.
    if (event.code !== 'Space' || event.target !== document.body) {
      return
    }
    if (handle()) {
      event.preventDefault()
    }
  })
}
